module.exports = __webpack_public_path__ + "static/img/UY.8d705445.png";